import * as z from "zod";

export interface DataTableOptions {
  page: number;
  size: number;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
  search?: string;
}

export const DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
export const DEFAULT_PAGE = 1;
export const DEFAULT_SIZE = 10;
export const DEFAULT_SEARCH = "";
export const DEFAULT_SORTBY = "";
export const DEFAULT_SORTDIRECTION = undefined;

export const DEFAULT_DATATABLE_OPTIONS: DataTableOptions = {
  page: DEFAULT_PAGE,
  size: DEFAULT_SIZE,
  sortBy: DEFAULT_SORTBY,
  sortDirection: DEFAULT_SORTDIRECTION,
  search: DEFAULT_SEARCH,
};

// to be used in DataTables/DataTableCards, which use useQuery with dynamic parameters (NOT with useClientDataTable!)
// needs "enabled" check on queries for page > 0
export const DEFAULT_DATATABLE_OPTIONS_INITIALLY_DISABLED: DataTableOptions = {
  ...DEFAULT_DATATABLE_OPTIONS,
  page: 0,
};

export const ACTION_COLUMN_ID = "actions";

export const dataTableSearchSchema = z.object({
  search: z.string().default(DEFAULT_SEARCH),
  page: z.number().default(DEFAULT_PAGE),
  size: z.number().default(DEFAULT_SIZE),
  sortBy: z.string().default(DEFAULT_SORTBY),
  sortDirection: z.union([z.literal("asc"), z.literal("desc")]).nullish(),
});
